import { render, staticRenderFns } from "./Interpret.vue?vue&type=template&id=6bcb8990&scoped=true"
import script from "./Interpret.vue?vue&type=script&lang=js"
export * from "./Interpret.vue?vue&type=script&lang=js"
import style0 from "./Interpret.vue?vue&type=style&index=0&id=6bcb8990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb8990",
  null
  
)

export default component.exports